/**
 * This code was generated by Builder.io.
 */
import React from "react";
import styles from "./PremiumSelection.module.css";
import { Step } from "./types";

const StepperSection: React.FC = () => {
  const steps: Step[] = [
    { number: 1, label: "Select Premium Type", active: true },
    { number: 2, label: "Select Office", active: false },
    { number: 3, label: "Select Product", active: false },
    { number: 4, label: "Create Product", active: false },
  ];

  return (
    <section className={styles.stepperSection}>
      {steps.map((step, index) => (
        <React.Fragment key={step.number}>
          <div className={styles.stepperStep}>
            <span
              className={`${styles.stepNumber} ${
                !step.active ? styles.inactiveStepNumber : ""
              }`}
              aria-current={step.active ? "step" : undefined}
            >
              {step.number}
            </span>
            <span
              className={`${styles.stepLabel} ${
                !step.active ? styles.inactiveStepLabel : ""
              }`}
            >
              {step.label}
            </span>
          </div>
          {index < steps.length - 1 && <div className={styles.stepDivider} />}
        </React.Fragment>
      ))}
    </section>
  );
};

export default StepperSection;
